import { validateToken as validateTokenApi } from "../../hooks/api/user/callbacks";
import { clearCookie, getToken, setCookie, setEditHintCookie, clearEditHintCookie } from "../../lib/utils";
import { IUserInfo } from "../../types/api/user";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface UserStore {
  isLoggedIn: boolean;
   isHydrated: boolean;
  token: string | null;
  user: IUserInfo | null;

  updateToken: (data: {
    token: string | null;
    user: IUserInfo | null;
  }) => void;

  updateUser: (user: IUserInfo) => void;

  logout: () => void;

  validateToken: () => Promise<boolean>;
}



export const useUserStore = create<UserStore>()(
  devtools((set, get) => {
const setAuthState = (data: {
  token: string;
  user: IUserInfo | null;
}) => {
  set({
    token: data.token,
    user: data.user,
    isLoggedIn: true,
  });

  setCookie("token", data.token);
  setEditHintCookie();
};

    const resetAuth = () => {
      set({
        isLoggedIn: false,
        token: null,
        user: null,
      });

      clearCookie("token");
      clearEditHintCookie();
    };
    return {
      isLoggedIn: false,
      isHydrated: false,
      token: null,
      user: null,

      updateToken: setAuthState,

      updateUser: (user) => {
        set({ user });
      },

      logout: resetAuth,

 validateToken: async () => {
  try {
    
     const token = getToken();

    if (!token) {
      resetAuth();
      set({ isHydrated: true });
      return false;
    }

    const res = await validateTokenApi();

    // 2. FIX: backend doesn't return "success"
    if (!res?.data?.data) {
      resetAuth();
      set({ isHydrated: true });
      return false;
    }


    set({
      token,
      user: res.data.data,
      isLoggedIn: true,
      isHydrated: true,
    });
    setEditHintCookie();

    return true;
  } catch {
    resetAuth();
    set({ isHydrated: true });
    return false;
  }
},
    };
  })
);